import React, {useEffect, useState} from "react";
import {getHopital} from "../misc/api";
import {useSelector} from "react-redux";
import ListPlaceByCommune from "./sub/ListPlaceByCommune";
import {useHistory} from "react-router-dom";

function ChoixHopital( props ) {

    let history = useHistory();

    const [ listeHopital, setListeHopital ] = useState( [] );

    const coordonnee = useSelector( ( state ) => state.coordonnee );

    const getAroundHopital = () => {
        getHopital( coordonnee.longitude, coordonnee.latitude, 60 )
            .then( response => {
                if( response.success ){
                    setListeHopital( response.data )
                }
            })
            .catch( error => console.log( error ) );
    }

    useEffect( getAroundHopital, []);

    return (
        <>
            <ListPlaceByCommune liste={ listeHopital } setpoi={ history.location.state } />
        </>
    );

}

export default ChoixHopital;